import React, { useState } from "react";
import customer from '../../assets/Why-choose-raiden/customer-centrics.png';
import flex from '../../assets/Why-choose-raiden/Flexible-solutions.png';
import game from '../../assets/Why-choose-raiden/Gamedesigns.png';
import qa from '../../assets/Why-choose-raiden/qualityassurances.png';

const BlockMetaData = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const blockMetaContent = [
    {
      _id: 1,
      icon: customer,
      title: "Streamlines Focus",
      metaHoverContent: `Understanding your specific needs and challenges is the first step in developing tailored solutions.`,
    },
    {
      _id: 2,
      icon: qa,
      title: "Guaranteed Execution",
      metaHoverContent: `We provide trusted solutions that meet your needs and ensure timely project delivery and quality control.`,
    },
    {
      _id: 3,
      icon: game,
      title: "Consistent Methodology",
      metaHoverContent: `Our team creates innovative gaming experiences by pushing the limits of creativity and technology.`,
    },
    {
      _id: 4,
      icon: flex,
      title: "Growth Driven solution",
      metaHoverContent: `We offer flexible development solutions that can change and expand to meet your demands.`,
    },
  ];

  return (
    <>
      <div className="row">
        {blockMetaContent.map((blockMeta, index) => (
          <div
            className="block-meta-data text-center col-lg-3 mb-4"
            key={blockMeta._id}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="line-dot-container">
              <div>
                <img
                  src={blockMeta.icon}
                  alt="icon"
                  style={{
                    height: '160px',
                    transition: 'transform 0.1s ease',
                    transform: hoveredIndex === index ? 'scale(1.1)' : 'scale(1)',
                  }}
                />
              </div>

              <h3
                className="text-center mt-lg h3-heading fw-bold mb-3"
                style={{ fontFamily: 'Raleway, sans-serif' }}
              >
                {blockMeta.title}
              </h3>
              <p
                className="text-center p-0 h1-para"
                style={{ fontSize: '18px' }}
              >
                {blockMeta.metaHoverContent}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BlockMetaData;
